import { useState } from 'react';
import { MediaPrior } from '../data-qa-types';
import { InformativePriorsCard, InformativePriorsGrid } from './InformativePriors';
import { StageSwitcher } from './StageSwitcher';

export interface PriorsStage {
  label: string;
  priors: MediaPrior[];
}

interface PriorsStageTabsProps {
  stages: PriorsStage[];
}

// Brand Equity's two modeling stages each declare their own priors CSV over
// genuinely different feature sets (e.g. GQV's paid-media priors vs. Total
// Business's single organic prior on GQV itself, confirmed 2026-08-18 against real
// away data). The switcher sits between the descriptive card and the chart grid it
// controls — directly above the diagrams that change when you click it.
export const PriorsStageTabs = ({ stages }: PriorsStageTabsProps) => {
  const [activeIndex, setActiveIndex] = useState(0);
  const active = stages[activeIndex];

  return (
    <>
      <InformativePriorsCard priors={active.priors} />
      <StageSwitcher
        prompt='This model has two stages — choose one to view its priors:'
        stages={stages.map(stage => ({ key: stage.label, label: stage.label }))}
        activeIndex={activeIndex}
        onSelect={setActiveIndex}
      />
      <InformativePriorsGrid priors={active.priors} />
    </>
  );
};
